import { gql } from "@apollo/client";

export const GET_MY_SUBSCRIPTIONS = gql`
  query getMySubscriptions {
    getMySubscriptions {
      id
      itemType
      itemName
      cadence
      dayOfWeek
      timeOfDay
      price
      firstChargePrice
      status
      nextRenewalAt
      lastRenewalAt
      cancelledAt
      cancelReason
      createdAt
    }
  }
`;

export const SUBSCRIBE_TO_MENU_ITEM = gql`
  mutation subscribeToMenuItem(
    $itemType: String!
    $cadence: String!
    $dayOfWeek: Int
    $timeOfDay: String
  ) {
    subscribeToMenuItem(
      itemType: $itemType
      cadence: $cadence
      dayOfWeek: $dayOfWeek
      timeOfDay: $timeOfDay
    ) {
      id
      itemType
      cadence
      dayOfWeek
      timeOfDay
      price
      status
      nextRenewalAt
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($subscriptionId: ID!) {
    cancelSubscription(subscriptionId: $subscriptionId)
  }
`;
